import api from '@/api'
import notifier from '@/notifier'

export default {
  namespaced: true,
  state: {
    total: 0,
    items: [],
    fetching: false,
    lastFetchOptions: null,
    tags: []
  },
  actions: {
    async fetch ({ state, commit, getters }, { type, identifier, options }) {
      commit('fetching')

      try {
        const { total, items } = await api.getProductsList(type, identifier, options)

        commit('setFetchData', {
          items, total, options
        })
      } catch (error) {
        notifier.error('Falha ao buscar os produtos.', 'Erro')
      }
    },
    async clearProductsMarketplace ({ state, commit }) {
      const items = []
      commit('setFetchData', {
        items
      })
    },
    async addItem ({ state, commit, getters }, { type, identifier, id }) {
      commit('fetching')

      try {
        const item = await api.getProduct(type, identifier, id)

        commit('addItem', item)
      } catch (error) {
        notifier.error('Falha ao buscar o produto.', 'Erro')
      }
    },
    fillTags ({ state, commit }, tags) {
      commit('setTags', tags)
    },
    addTag ({ state, commit }, tag) {
      commit('addTag', tag)
    }
  },
  getters: {
    getByProductId: state => productId => state.items.find(product => product.productId === productId),
    getById: state => id => state.items.find(product => product._id.$oid === id),
    getBySku: state => sku => state.items.find(product => product.sku === sku)
  },
  mutations: {
    setFetchData (state, { items, total, options }) {
      state.total = total
      state.items = items
      state.lastFetchOptions = {...options}
      state.fetching = false
    },
    fetching (state) {
      state.fetching = true
    },
    addItem (state, item) {
      state.items.push(item)
      state.total = state.items.length
    },
    setTags (state, newTags) {
      state.tags = newTags
    },
    addTag (state, tag) {
      state.tags.push(tag)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/productsMarketplace.js